
// 给mutations的方法定义别名
const mutationTypes = {
  /// 管理授权 Type 1 = 管理授权人 2 = 档案授权人 3 = 建议授权人
  MANAGER_AUTHTYPE: 'MANAGER_AUTHTYPE', //
  /// 岗位的请求 year 和 month 信息， 保存
  TASK_REQYEARMONTH: 'TASK_REQYEARMONTH', //
  /// 岗位考核表 - 是否是点击 查看 任务详情
  TASK_SCORE_TASKDETAIL: 'TASK_SCORE_TASKDETAIL',
  /// 岗位考核表 - 是否是点击 查看 任务详情
  TASK_KEEP_ARRAY: 'TASK_KEEP_ARRAY'
}

function getInitialState () {
  return {
    // 管理授权 默认为 1
    managerAuthType: 1,
    taskReqYearMonth: {},
    taskScoreLookDetail: {
      lookDetail: false, // 查看详情
      taskDetail: {}
    },
    keepArray: []
  }
}

// mttation 处理结果
const mutations = {
  // 订单详情
  [mutationTypes.MANAGER_AUTHTYPE] (state, res) {
    // 把返回结果,赋予state里面的参数
    state.managerAuthType = res
  },
  // 任务请求 的 年月信息
  [mutationTypes.TASK_REQYEARMONTH] (state, res) {
    // 把返回结果,赋予state里面的参数
    state.taskReqYearMonth = res
  },
  /// 岗位考核表 - 是否是点击 查看 任务详情
  [mutationTypes.TASK_SCORE_TASKDETAIL] (state, res) {
    // 把返回结果,赋予state里面的参数
    state.taskScoreLookDetail = res
  },
  /// 岗位考核表 - 是否是点击 查看 任务详情
  [mutationTypes.TASK_KEEP_ARRAY] (state, name) {
    // 把返回结果,赋予state里面的参数
    state.keepArray.push(name)
  }

}

// action 发起请求
const actions = {

  setManagerAuthType ({commit, state}, res) {
    console.log('ivu-icon-android-restaurant')

    commit(mutationTypes.MANAGER_AUTHTYPE, res)
  },
  setTaskReqYearMonth ({commit, state}, res) {
    commit(mutationTypes.TASK_REQYEARMONTH, res)
  },
  setTaskScoreTaskDetail ({commit, state}, res) {
    commit(mutationTypes.TASK_SCORE_TASKDETAIL, res)
  },
  commitTaskKeepArray ({commit, state}, name) {
    commit(mutationTypes.TASK_KEEP_ARRAY, name)
  }
}

// module里面的参数
const getters = {
  getManagerAuthType: state =>
    state.managerAuthType,
  getTaskReqYearMonth: state =>
    state.taskReqYearMonth,
  getTaskScoreTaskDetail: state =>
    state.taskScoreLookDetail
}

// module 要暴露出去的东西
const module = {
  namespaced: true,
  getters,
  state: getInitialState(),
  mutations,
  actions
}

// 把内容暴露出去
export default module



// WEBPACK FOOTER //
// ./src/store/modules/company.js